module.exports = new __parcel__URL__("sedativeshot.cf8ed2d0.png").toString();